var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { attr, hasMany } from '@ember-data/model';
export let State = /*#__PURE__*/function (State) {
  State["INITIALIZED"] = "INITIALIZED";
  State["PENDING"] = "PENDING";
  State["ACTIVE"] = "ACTIVE";
  State["DISABLED"] = "DISABLED";
  State["PENDING_DELETED"] = "PENDING_DELETED";
  State["DELETED"] = "DELETED";
  return State;
}({});
let Menu = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('date'), _dec6 = attr('date'), _dec7 = attr('date'), _dec8 = hasMany('menu-sync/menu-hour', {
  async: false
}), _class = class Menu extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "menuConfigurationId", _descriptor, this);
    _initializerDefineProperty(this, "state", _descriptor2, this);
    _initializerDefineProperty(this, "rootCategory", _descriptor3, this);
    _initializerDefineProperty(this, "previewURL", _descriptor4, this);
    _initializerDefineProperty(this, "lastSyncedAt", _descriptor5, this);
    _initializerDefineProperty(this, "createdAt", _descriptor6, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor7, this);
    _initializerDefineProperty(this, "menuHours", _descriptor8, this);
  }
  get isInitialized() {
    return this.state === State.INITIALIZED;
  }
  get isPending() {
    return this.state === State.PENDING;
  }
  get isPendingDeleted() {
    return this.state === State.PENDING_DELETED;
  }
  get isDeletedState() {
    return this.state === State.DELETED;
  }

  // The disabled state is the backend state for when a seller wants to hide
  // their menu on a third party integration, we represent this in the UI as "Hidden"
  get isDisabled() {
    return this.state === State.DISABLED;
  }
  get isActive() {
    return this.state === State.ACTIVE;
  }
  get variantType() {
    switch (true) {
      case this.isInitialized:
        return 'normal';
      case this.isActive:
        return 'success';
      case this.isDisabled:
        return 'normal';
      case this.isPending:
      case this.isPendingDeleted:
        return 'normal';
      case this.isDeletedState:
        return 'critical';
      default:
        return 'normal';
    }
  }
  get translationString() {
    switch (true) {
      case this.isInitialized:
        return 'onlineChannels.doordash.common.state.pending';
      case this.isActive:
        return 'onlineChannels.doordash.common.state.active';
      case this.isDisabled:
        return 'onlineChannels.doordash.common.state.hidden';
      case this.isPending:
      case this.isPendingDeleted:
        return 'onlineChannels.doordash.common.state.pending';
      case this.isDeletedState:
        return 'onlineChannels.doordash.common.state.deleted';
      default:
        return 'onlineChannels.doordash.common.state.active';
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "menuConfigurationId", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "state", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "rootCategory", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "previewURL", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "lastSyncedAt", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "menuHours", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Menu as default };